// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sing-play[data-v-318d1562]{width:100%;height:100vh;background:#fff}.sing-play[data-v-318d1562] .player-control-board .player-control{position:static;justify-content:center}.sing-play[data-v-318d1562] .play-score-setting .score-modal{right:auto}.sing-play-not-render[data-v-318d1562]{display:flex;align-items:center;justify-content:center;width:100%;height:100vh;color:#b05d23;background:#fff;font-size:40px;font-weight:700}", ""]);
// Exports
module.exports = exports;
